import echarts from '@/config/echarts/index.js'
import moment from 'moment'

export function getLiveOption () {
  const data = []
  return {
    color: ['#66ff99', '#2db7f5', '#ff6600', '#ff33cc'],
    legend: {
      // selectedMode: 'single',
      show: true,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 15,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '1rem'
      }
    },
    grid: {
      left: 50,
      right: 30,
      top: 30,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.8vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      },
      formatter: function (params) {
        let html = ''
        for (let i = 0; i < params.length; i++) {
          if (i === 0) {
            html += moment(Number(params[0].axisValue)).format('DD日HH时') + '</br>'
          }
          html += `${params[i].marker}${params[i].seriesName} ${params[i].value}℃</br>`
        }
        return html
      }
    },
    xAxis: {
      data: data,
      axisTick: { length: 5 },
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '1rem',
        formatter: function (value) {
          return moment(Number(value)).format('HH')
        }
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '(℃)',
        nameLocation: 'end',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '1rem',
          align: 'right'
        },
        splitLine: {
          show: false
        },
        splitNumber: 4,
        axisLabel: {
          color: '#FFF',
          fontSize: '1rem'
        }
      }
    ],
    series: [
      {
        name: '1m温度',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.9rem',
          color: '#FFF'
        },
        symbol: (value, params) => {
          if (params.dataIndex % 2 === 0) {
            return 'circle'
          } else {
            return 'none'
          }
        },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 3
            }
          }
        }
      },
      {
        name: '2m温度',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.9rem',
          color: '#FFF'
        },
        symbol: (value, params) => {
          if (params.dataIndex % 2 === 0) {
            return 'circle'
          } else {
            return 'none'
          }
        },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 3
            }
          }
        }
      },
      {
        name: '2.5m温度',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.9rem',
          color: '#FFF'
        },
        symbol: (value, params) => {
          if (params.dataIndex % 2 === 0) {
            return 'circle'
          } else {
            return 'none'
          }
        },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 3
            }
          }
        }
      },
      {
        name: '3.2m温度',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.9rem',
          color: '#FFF'
        },
        symbol: (value, params) => {
          if (params.dataIndex % 2 === 0) {
            return 'circle'
          } else {
            return 'none'
          }
          // return 'circle'
        },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 3
            }
          }
        }
      }
    ]
  }
}
